module.exports = __webpack_public_path__ + "static/media/jamstack.59dabb57.png";